module.exports = __webpack_public_path__ + "img/kefuIcon.9a4ecfa7.png";